<app-dialog-header headerKey="button.generateReport"> </app-dialog-header>
<mat-dialog-content>
  <span> {{ 'user.report' | loc }}</span>
</mat-dialog-content>
<mat-dialog-actions class="centered flex-column">
  <button mat-stroked-button class="mat-primary submit-button button-rounded" type="button" (click)="generateReport()">
    {{ 'button.generateReport' | loc }}
  </button>
  <div *ngIf="isSuperAdmin" class="margin-top-20 flex-column">
    <i class="foreground gray">Fliko Admin only</i>
    <button mat-stroked-button class="mat-gray submit-button button-rounded margin-bottom-10" (click)="generateUnits()">
      Jednostki pod import (np. kodów jednostek)
    </button>
    <button mat-stroked-button class="mat-gray submit-button button-rounded" (click)="generateLandlords()">
      Mieszkańcy pod import (np. kodów właścicieli)
    </button>
  </div>
</mat-dialog-actions>
